import { render, staticRenderFns } from "./settingFinance.vue?vue&type=template&id=3ab33ddc&scoped=true&"
import script from "./settingFinance.vue?vue&type=script&lang=js&"
export * from "./settingFinance.vue?vue&type=script&lang=js&"
import style0 from "./settingFinance.vue?vue&type=style&index=0&id=3ab33ddc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab33ddc",
  null
  
)

export default component.exports